/******************************************************************************
 * Memokid: A game to train one's memory                                      *
 * Copyright (C) 2022 Lukas Laag                                              *
 * This file is part of Memokid                                               *
 *                                                                            *
 * Memokid is free software: you can redistribute it and/or modify            *
 * it under the terms of the GNU General Public License as published by       *
 * the Free Software Foundation, either version 3 of the License, or          *
 * (at your option) any later version.                                        *
 *                                                                            *
 * Memokid is distributed in the hope that it will be useful,                 *
 * but WITHOUT ANY WARRANTY; without even the implied warranty of             *
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the              *
 * GNU General Public License for more details.                               *
 *                                                                            *
 * You should have received a copy of the GNU General Public License          *
 * along with Memokid.  If not, see <https://www.gnu.org/licenses/>.          *
 *                                                                            *
 ******************************************************************************/

const catalog = {
  locale: 'fr',
  messages: {
    'about.about': 'A propos de Memokid',
    'about.versionTitle': 'Version',
    'about.devTitle': 'Conception et développement',
    'about.artTitle': 'Graphismes',
    'about.artValue': "Les dessins sur les cartes de ce jeu proviennent de <a href='http://www.openclipart.org'>http://www.openclipart.org</a>. L'auteur remercie les nombreux artistes du site",
    'about.translationsTitle': 'Traductions',
    'about.trLanguage': 'Langue',
    'about.trTranslator': 'Traducteur',
    'about.thanksTitle': 'Remerciements',
    'about.thanksValue': "Christophe Porteneuve @ <a href='http://delicious-insights.com'>Delicious Insights</a> pour son excellente formation ES2015 et React",
    'about.copyrightTitle': 'Licence',
    'about.copyrightValue': '© 2017-2023 Lukas Laag. Ce logiciel est soumis à la licence <a href="https://www.gnu.org/licenses/gpl-3.0.en.html">GPLv3</a>. Pour plus de détails, le code source, d\'autres versions, rendez-vous sur <a href="https://webinstit.net/memokid/">webinstit.net</a>',
    'common.home': 'accueil',
    'common.cancel': 'annuler',
    'common.add': 'ajouter',
    'common.modify': 'modifier',
    'common.remove': 'supprimer',
    'common.ok': 'ok',
    'common.loading': 'Chargement...',
    'decks.deck_0': 'Noël',
    'decks.deck_1': 'Lettres majuscules',
    'decks.deck_2': 'Animaux',
    'decks.deck_3': 'Animaux Animés',
    'decks.deck_4': 'Nourriture',
    'decks.deck_5': 'Moyens de transport',
    'decks.deck_6': 'Lettres minuscules',
    'decks.deck_7': 'Chiffres',
    'decks.deck_8': 'Instruments de Musique',
    'decks.deck_9': 'Drapeaux',
    'decks.deck_10': 'Ustensiles de Cuisine',
    'decks.deck_11': 'Pâques',
    'game.stopMessage': "Interrompre la partie en cours et revenir à l'écran d'accueil ?",
    'game.demo': 'demo {id}',
    'game.player': 'Joueur',
    'game.computer': 'Ordinateur',
    'game.gameOver': 'Fin de partie',
    'game.win': '{players} remporte le jeu. Félicitations !',
    'game.win_plural': '{players} remportent le jeu. Félicitations !',
    'game.draw': 'Match nul. Félicitations à tous les joueurs !',
    'game.conjunction': 'et',
    'scores.title': 'Scores des dernières parties',
    'scores.noscores': "Il n'y a pas encore eu de parties jouées",
    'scores.when': 'Quand',
    'scores.players': 'Joueurs',
    'scores.scores': 'Scores',
    'scores.vs': 'vs',
    'scores.to': 'à',
    'settings.deckHeader': 'Jeu de cartes',
    'settings.plyCountHeader': 'Nombre de cartes par pli',
    'settings.cardCountHeader': 'Nombre de cartes du jeu',
    'settings.playersHeader': 'Joueurs',
    'settings.addPlayer': 'Ajouter un joueur',
    'settings.modifyPlayer': 'Modifier un joueur',
    'settings.removePlayerMessage': "Voulez-vous supprimer le joueur '{player}' ?",
    'settings.playerLabel': 'Nom du joueur',
    'settings.playerTypeHeader': 'Type de joueur',
    'settings.humanPlayer': 'Joueur humain',
    'settings.computerPlayer': 'Ordinateur',
    'settings.computerLevelHeader': "Niveau de l'ordinateur",
    'settings.language': 'Langue',
    'title.aboutButton': 'a propos',
    'title.settingsButton': 'réglages',
    'title.scoresButton': 'scores',
    'title.newGameButton': 'nouvelle partie',
    'title.gameType': 'Type de jeu: {cardCount} cartes, {matchCount} cartes par pli',
    'title.player': '1 Joueur',
    'title.player_plural': '{count} Joueurs',
    'title.playerLevel': 'niveau {level}'
  }
}
export default catalog
